import { makeSvgIcon } from '../makeSvgIcon'

export const tap = makeSvgIcon(
  <path d="M9.62597 3.09229C8.97892 0.67748 6.08114 1.45394 6.72819 3.86875L9.05756 12.5621C10.0928 16.4258 4.15856 9.73365 2.48555 11.2172C-0.0239998 13.4426 9.1269 16.6846 10.421 21.5142C10.9386 23.4461 13.8364 22.6696 14.8023 22.4108L15.7683 22.152L15.7683 22.152C16.7342 21.8932 18.6661 21.3755 19.3732 20.1508C20.7874 17.7013 20.7313 13.6283 20.2004 11.6469C19.4239 8.74916 15.0426 7.85257 11.1789 8.88785L9.62597 3.09229Z" />
)
